'use strict';

angular.module('chatEngine.interceptor', [
    'chatEngine.services'
])

// This is a dependency of $http.
// To avoid circular dependencies, parameters are injected "just in time" using $injector.invoke.
.factory('authInterceptor', ['$q', '$injector', function($q, $injector) {
    var interceptorModal = null;

    function handleDisconnect($http, Dialog, rejection) {
        var dfd = $q.defer();

        var dialog = Dialog.instance();
        if(dialog && interceptorModal !== dialog) {
            // If another dialog is open, fail since we do not allow multiple dialogs
            return $q.reject(rejection);
        } else if(dialog === null) {
            interceptorModal = Dialog.modal({
                backdrop: 'static',
                resolve: {
                    config: function() {
                        return {
                            title: 'Oops!',
                            message: 'It looks like you\'ve been disconnected, ' +
                            'please check your connection and try again.',
                            okText: 'Try Again'
                        };
                    }
                }
            });
        }
        // Bind retry handler
        interceptorModal.result.then(function() {
            dfd.resolve($http(rejection.config));
        }, function() {
            dfd.reject(rejection);
        });

        return dfd.promise;
    }
    handleDisconnect.$inject = ['$http', 'Dialog', 'rejection'];

    function handle403($location, $window, Dialog, authService, response) {
        function logout() {
            authService.clearAuthCookies();
            $window.location.href = '/logout';
        }

        // 403: the user is logged in but the request is forbidden
        if (response.data && response.data.error === 'TosNotAccepted') {
            // Always redirect to the TOS
            if ($location.path() !== '/tos') {
                $location.path('/tos');
            } else {
                $location.search('username', null);
            }
            return $q.defer().promise;
        } else if(response.data && response.data.message === 'Unauthorized user') {
            // The user is logged in but shouldn't be (access revoked to current bot). Let's log them out.
            logout();
            return $q.defer().promise;
        } else {
            return $q.reject(response);
        }
    }

    handle403.$inject = ['$location', '$window', 'Dialog', 'authService', 'response'];

    function handle401($location, authService, sessionDataService) {
        // 401: the user is not even logged in, let's redirect him to a public page if needed

        // Need to erase all traces of the user being logged in
        authService.clearAuthCookies();
        sessionDataService.clear();

        // Is the user on a page that does not require to be logged in?
        var allowedPaths = [/^\/login$/, /^\/home$/, /^\/terms$/, /^\/docs/, /^\/verify/];
        var allow = false;
        angular.forEach(allowedPaths, function(path) {
            if($location.path() && $location.path().search(path) >= 0) {
                allow = true;
            }
        });

        if(!allow) {
            $location.path('/home');
        } else {
            $location.search('username', null);
        }

        return $q.defer().promise;
    }

    handle401.$inject = ['$location', 'authService', 'sessionDataService'];

    return {
        responseError: function(rejection) {
            if (rejection.status === 401) {
                return $injector.invoke(handle401, this, {response: rejection});
            } else if(rejection.status === 403) {
                return $injector.invoke(handle403, this, {response: rejection});
            } else if (rejection.status === 0) {
                return $injector.invoke(handleDisconnect, this, {rejection: rejection});
            } else {
                return $q.reject(rejection);
            }
        }
    };
}]);
